// 26.1.11 Reflect.ownKeys(target)
var $export = require('./$.export');

$export($export.S, 'Reflect', {ownKeys: require('./$.own-keys')});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.reflect.own-keys.js
// module id = 153
// module chunks = 0